import {
  CREATE_CONTACT_LOG_REQUEST,
  CREATE_CONTACT_LOG_SUCCESS,
  CREATE_CONTACT_LOG_FAILURE,

  FETCH_CONTACT_LOGS_REQUEST,
  FETCH_CONTACT_LOGS_SUCCESS,
  FETCH_CONTACT_LOGS_FAILURE,

  FETCH_USER_CONTACT_LOGS_REQUEST,
  FETCH_USER_CONTACT_LOGS_SUCCESS,
  FETCH_USER_CONTACT_LOGS_FAILURE,

  UPDATE_CONTACT_LOG_REQUEST,
  UPDATE_CONTACT_LOG_SUCCESS,
  UPDATE_CONTACT_LOG_FAILURE,

  DELETE_CONTACT_LOG_REQUEST,
  DELETE_CONTACT_LOG_SUCCESS,
  DELETE_CONTACT_LOG_FAILURE,
} from "../actions/types";


const initialState = {
  logs: [],

  loading: false,

  error: null,

  message: "",

  pagination: {
    total: 0,
    page: 1,
    size: 10,
    pages: 1,
  },
};


export default function contactLogReducer(
  state = initialState,
  action
) {

  switch (action.type) {

 
    // FETCH ALL CONTACT LOGS
 

    case FETCH_CONTACT_LOGS_REQUEST:

      return {
        ...state,
        loading: true,
        error: null,
      };


    case FETCH_CONTACT_LOGS_SUCCESS:

      return {
        ...state,

        loading: false,

        logs:
          action.payload?.results ||
          [],

        pagination: {
          total:
            action.payload?.total ||
            0,

          page:
            action.payload?.page ||
            1,

          size:
            action.payload?.size ||
            10,

          pages:
            action.payload?.pages ||
            1,
        },
      };


    case FETCH_CONTACT_LOGS_FAILURE:

      return {
        ...state,
        loading: false,
        error: action.payload,
      };


 
    // FETCH CONTACT LOGS FOR SPECIFIC USER
 

    case FETCH_USER_CONTACT_LOGS_REQUEST:

      return {
        ...state,
        loading: true,
        error: null,
      };


    case FETCH_USER_CONTACT_LOGS_SUCCESS: {

      const logs =
        Array.isArray(action.payload)
          ? action.payload
          : action.payload?.results || [];

      return {
        ...state,

        loading: false,

        logs,

        pagination: {
          total: logs.length,
          page: 1,
          size: logs.length,
          pages: 1,
        },
      };
    }


    case FETCH_USER_CONTACT_LOGS_FAILURE:

      return {
        ...state,
        loading: false,
        error: action.payload,
      };


 
    // CREATE CONTACT LOG
 

    case CREATE_CONTACT_LOG_REQUEST:

      return {
        ...state,
        loading: true,
        error: null,
      };


    case CREATE_CONTACT_LOG_SUCCESS:

      return {
        ...state,

        loading: false,

        logs: [
          action.payload,
          ...state.logs,
        ],

        pagination: {
          ...state.pagination,

          total:
            state.pagination.total + 1,
        },
      };


    case CREATE_CONTACT_LOG_FAILURE:

      return {
        ...state,
        loading: false,
        error: action.payload,
      };


 
    // UPDATE CONTACT LOG
 

    case UPDATE_CONTACT_LOG_REQUEST:

      return {
        ...state,
        loading: true,
        error: null,
      };


    case UPDATE_CONTACT_LOG_SUCCESS:

      return {
        ...state,

        loading: false,

        logs: state.logs.map(
          (log) =>
            log.contact_log_id ===
            action.payload.contact_log_id
              ? action.payload
              : log
        ),
      };


    case UPDATE_CONTACT_LOG_FAILURE:

      return {
        ...state,
        loading: false,
        error: action.payload,
      };


 
    // DELETE CONTACT LOG
 

    case DELETE_CONTACT_LOG_REQUEST:

      return {
        ...state,
        loading: true,
        error: null,
      };


    case DELETE_CONTACT_LOG_SUCCESS:

      return {
        ...state,

        loading: false,

        logs: state.logs.filter(
          (log) =>
            log.contact_log_id !==
            action.payload
        ),

        pagination: {
          ...state.pagination,

          total:
            state.pagination.total > 0
              ? state.pagination.total - 1
              : 0,
        },
      };


    case DELETE_CONTACT_LOG_FAILURE:

      return {
        ...state,
        loading: false,
        error: action.payload,
      };


 
    // DEFAULT
 

    default:
      return state;
  }
}